import * as React from 'react';
import { TableCellProps } from './TableProps';

type Props = TableCellProps<any, number>;

export const CurrencyDecimalCell: React.FC<Props> = ({
  value,
  formattedValue,
}) => {
  return <span>{value !== null && value !== undefined && formattedValue}</span>;
};
